<template>
    <div>
        <UiComponentTypography tag="h5"> {{ filter }} </UiComponentTypography>
        <div class="mt-4">
            <UiComponentNumberSelector v-bind="options" v-model="amount" />
        </div>
    </div>
</template>

<script lang="ts" setup>
const amount = defineModel({ type: Number, default: 1 });

const props = defineProps({
    options: {
        type: Object,
    },
    filter: {
        type: String,
        default: "",
    },
    deactivateIndexes: {
        type: Array,
    },
});
</script>

<style></style>
